
import { debounce } from 'lodash';
interface onKeyDownObj{
    e: any,
    ref: any,
    apiId:any,
    type:string,
    typeProducts: string,
    event?: any
}
const orderCutKey = () => {

}


//键盘按下事件
orderCutKey.onKeyDown = debounce((onKeyDownObj:onKeyDownObj) => {
    const {e,ref,apiId,event,typeProducts,type}=onKeyDownObj
    if (typeof ref === "undefined") return;
    const { current } = ref;
    if (typeof current === "undefined" || !current) return
    
    
    const { altKey } = e;

    if (altKey) {
        switch (e.key) {

            case "a": // 新增订单数据
                ref.current.handleNew()
                break;
            // case "d": // 删除订单数据
            //     ref.current.handleDelete()
            //     break;
            case "m": // 编辑订单数据
                ref.current.handleEditEx()
                break;
            case "x": //退出
                ref.current.handleExit()
                break;
            case "p": //打印
            if (current.currentRow) {
                event({apiId,typeProducts,item:ref.current.currentRow,type})
            }
                break;

        }
    }

    if (typeof ref.current.maxLength === "undefined") return
    if (typeof ref.current.keyOnExpandClick === "undefined") return


    switch (e.key) {
        case "ArrowUp":
            let indexA = localStorage.getItem("num")
            let nowIndexA = Number(indexA) - 1;

            if (nowIndexA < 0) {

                nowIndexA = 0
            }
            localStorage.setItem("num", String(nowIndexA))
            ref.current.keyOnExpandClick()

            break;
        case "ArrowDown":


            let indexB = localStorage.getItem("num")
            let nowIndexB = Number(indexB) + 1;
            if (nowIndexB > Number(ref.current.maxLength)) {
                nowIndexB = Number(ref.current.maxLength)
            }
            localStorage.setItem("num", String(nowIndexB))

            ref.current.keyOnExpandClick(true)

            break;

    }

}, 500)






export default orderCutKey;